// 3rd party
import { Component, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';

// services
import { AuthService } from 'app/shared/services/auth/auth.service';

@Component({
  selector: 'app-lock-screen',
  templateUrl: './lock-screen.component.html',
  styleUrls: ['./lock-screen.component.css']
})
export class LockScreenComponent implements OnInit, OnDestroy {

  @ViewChild('userPassword') userPassword: ElementRef;

  public userName: string;

  constructor(
    private authService: AuthService,
    public dialogRef: MatDialogRef<LockScreenComponent>,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.userPassword.nativeElement.focus();
  }

  ngOnDestroy() { }

  unlock() {
    let email: string = JSON.parse(localStorage.getItem('currentUser'))['email'];
    let password: string = this.userPassword.nativeElement.value;
    if (password === '') {
      this.userPassword.nativeElement.focus();
      return;
    }
    localStorage.setItem('lastLogin', email);
    this.authService.login(email, password)
      .then(user => {
        this.dialogRef.close(true);
      })
      .catch((error: any) => {
        let errMsg: string;
        if (error && error.status === 401) {
          errMsg = error.statusText;
          this.userPassword.nativeElement.value = '';
          this.userPassword.nativeElement.focus();
          this.snackBar.open('Senha inválida!', 'OK', { duration: 2000 });
        } else {
          errMsg = `${error.status} - ${error.statusText || ''}`;
        }
        return Promise.reject(errMsg);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/lock-screen/lock-screen.component.ts